import {distributionWebsocketCommands} from '../../constants/distributionWebsocketCommands';
import {commercialWebsocketCommands} from '../../constants/commercialWebsocketCommands';
import {marketingWebsocketCommands} from '../../constants/marketingWebsocketCommands';
import {domains} from '../../constants/Utils';

export const ADMIN_FREQUENT_QUESTION_SELECT_GROUP = 'ADMIN_FREQUENT_QUESTION_SELECT_GROUP';
export const ADMIN_FREQUENT_QUESTION_FETCH = 'ADMIN_FREQUENT_QUESTION_FETCH';
export const ADMIN_FREQUENT_QUESTION_ADD = 'ADMIN_FREQUENT_QUESTION_ADD';
export const ADMIN_FREQUENT_QUESTION_EDIT = 'ADMIN_FREQUENT_QUESTION_EDIT';
export const ADMIN_FREQUENT_QUESTION_UPDATE = 'ADMIN_FREQUENT_QUESTION_UPDATE';
export const ADMIN_FREQUENT_QUESTION_MOVE = 'ADMIN_FREQUENT_QUESTION_MOVE';
export const ADMIN_FREQUENT_QUESTION_SWITCH = 'ADMIN_FREQUENT_QUESTION_SWITCH';
export const ADMIN_FREQUENT_QUESTION_REMOVE = 'ADMIN_FREQUENT_QUESTION_REMOVE';

export const storeSelectedCountryGroup = countryGroup => dispatch =>
    dispatch({
        type: ADMIN_FREQUENT_QUESTION_SELECT_GROUP,
        payload: countryGroup
    });

export const fetchFrequentQuestion = (domain, group) => dispatch => {
    switch (domain) {
        case domains.DISTRIBUTION: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_FETCH,
                distributionWebsocket: true,
                command: distributionWebsocketCommands.DISTRIBUTION_FREQUENT_QUESTION_GET,
                payload: {group}
            });
        }
        case domains.COMMERCIAL: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_FETCH,
                commercialWebsocket: true,
                command: commercialWebsocketCommands.COMMERCIAL_FREQUENT_QUESTION_GET,
                payload: {group}
            });
        }
        case domains.MARKETING: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_FETCH,
                marketingWebsocket: true,
                command: marketingWebsocketCommands.MARKETING_FREQUENT_QUESTION_GET,
                payload: {group}
            });
        }
    }
};

export const addFrequentQuestion = (domain, frequentQuestion) => dispatch => {
    switch (domain) {
        case domains.DISTRIBUTION: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_ADD,
                distributionWebsocket: true,
                command: distributionWebsocketCommands.DISTRIBUTION_FREQUENT_QUESTION_CREATE,
                payload: {frequentQuestion}
            });
        }
        case domains.COMMERCIAL: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_ADD,
                commercialWebsocket: true,
                command: commercialWebsocketCommands.COMMERCIAL_FREQUENT_QUESTION_CREATE,
                payload: {frequentQuestion}
            });
        }
        case domains.MARKETING: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_ADD,
                marketingWebsocket: true,
                command: marketingWebsocketCommands.MARKETING_FREQUENT_QUESTION_CREATE,
                payload: {frequentQuestion}
            });
        }
    }
};

export const editFrequentQuestion = index => dispatch => {
    dispatch({
        type: ADMIN_FREQUENT_QUESTION_EDIT,
        payload: {index}
    });
};

export const updateFrequentQuestion = (domain, frequentQuestion) => dispatch => {
    switch (domain) {
        case domains.DISTRIBUTION: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_UPDATE,
                distributionWebsocket: true,
                command: distributionWebsocketCommands.DISTRIBUTION_FREQUENT_QUESTION_UPDATE,
                payload: {frequentQuestion}
            });
        }
        case domains.COMMERCIAL: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_UPDATE,
                commercialWebsocket: true,
                command: commercialWebsocketCommands.COMMERCIAL_FREQUENT_QUESTION_UPDATE,
                payload: {frequentQuestion}
            });
        }
        case domains.MARKETING: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_UPDATE,
                marketingWebsocket: true,
                command: marketingWebsocketCommands.MARKETING_FREQUENT_QUESTION_UPDATE,
                payload: {frequentQuestion}
            });
        }
    }
};

export const moveFrequentQuestion = (domain, frequentQuestion, oldIndex) => dispatch => {
    switch (domain) {
        case domains.DISTRIBUTION: {
            dispatch({
                type: ADMIN_FREQUENT_QUESTION_SWITCH,
                payload: {oldIndex, newIndex: frequentQuestion.position, frequentQuestion}
            });
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_MOVE,
                distributionWebsocket: true,
                command: distributionWebsocketCommands.DISTRIBUTION_FREQUENT_QUESTION_MOVE,
                payload: {frequentQuestion}
            });
        }
        case domains.COMMERCIAL: {
            dispatch({
                type: ADMIN_FREQUENT_QUESTION_SWITCH,
                payload: {oldIndex, newIndex: frequentQuestion.position, frequentQuestion}
            });
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_MOVE,
                commercialWebsocket: true,
                command: commercialWebsocketCommands.COMMERCIAL_FREQUENT_QUESTION_MOVE,
                payload: {frequentQuestion}
            });
        }
        case domains.MARKETING: {
            dispatch({
                type: ADMIN_FREQUENT_QUESTION_SWITCH,
                payload: {oldIndex, newIndex: frequentQuestion.position, frequentQuestion}
            });
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_MOVE,
                marketingWebsocket: true,
                command: marketingWebsocketCommands.MARKETING_FREQUENT_QUESTION_MOVE,
                payload: {frequentQuestion}
            });
        }
    }
};

export const removeFrequentQuestion = (domain, frequentQuestion) => dispatch => {
    switch (domain) {
        case domains.DISTRIBUTION: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_REMOVE,
                distributionWebsocket: true,
                command: distributionWebsocketCommands.DISTRIBUTION_FREQUENT_QUESTION_DELETE,
                payload: {frequentQuestion}
            });
        }
        case domains.COMMERCIAL: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_REMOVE,
                commercialWebsocket: true,
                command: commercialWebsocketCommands.COMMERCIAL_FREQUENT_QUESTION_DELETE,
                payload: {frequentQuestion}
            });
        }
        case domains.MARKETING: {
            return dispatch({
                type: ADMIN_FREQUENT_QUESTION_REMOVE,
                marketingWebsocket: true,
                command: marketingWebsocketCommands.MARKETING_FREQUENT_QUESTION_DELETE,
                payload: {frequentQuestion}
            });
        }
    }
};


